import axios from "axios";
import { toast } from "sonner";

// API base URL is env-driven for local/preview and falls back to the
// production DPDPCRM API in built artefacts / deployments where the env
// variable is missing.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://api.dpdpcrm.com";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dpdp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("dpdp_token");
      localStorage.removeItem("dpdp_user");
      if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/portal")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

// Authenticated file download — plain <a href> / window.open cannot send the
// Bearer token, so all exports must go through these helpers.
export const downloadFile = async (path, filename) => {
  try {
    const res = await api.get(path, { responseType: "blob" });
    const type = res.data?.type || "";
    const extMap = { "application/pdf": ".pdf", "application/zip": ".zip", "image/png": ".png",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ".docx",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ".xlsx" };
    let name = filename || decodeURIComponent(path.split("/").pop().split("?")[0]) || "download";
    if (!/\.[a-z0-9]{2,5}$/i.test(name) && extMap[type]) name += extMap[type];
    const url = window.URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => window.URL.revokeObjectURL(url), 15000);
  } catch (e) {
    toast.error(e?.response?.status === 403 ? "Not permitted to download this file" : "Download failed");
  }
};

export const openFile = async (path) => {
  try {
    const res = await api.get(path, { responseType: "blob" });
    const url = window.URL.createObjectURL(res.data);
    window.open(url, "_blank");
    setTimeout(() => window.URL.revokeObjectURL(url), 120000);
  } catch {
    toast.error("Failed to open file");
  }
};

export default api;
